import React from 'react';
import PropTypes from 'prop-types';

import Steps from './Steps';
import EditAddress from './EditAddress';
import Api from '../../Api';

export default class AddAddressStep extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.navigate = this.navigate.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      user: Api.cache.getUser(),
      retailer: Api.cache.getRetailer()
    };
  }

  componentWillMount() {
    Api.getUser(true).then(
      user => {
        this.setState({user});
      }
    );

    Api.getLastSelectedRetailer()
    .then(
      retailerToken => {
        if (!retailerToken) return;

        return Api.getRetailer(retailerToken, true);
      }
    )
    .then(
      retailer => {
        this.setState({retailer});
      }
    );
  }

  navigate(to) {
    this.context.router.push(to);
  }

  nextStep() {
    this.navigate('/checkout/delivery');
  }

  save(address) {
    return Api.saveUserAddress(address)
      .then(response => {
        this.nextStep();
        return response;
      })
      .catch(error => {
        this.setState({
          error
        });
      });
  }

  render() {
    if (!this.state.user) {
      return null;
    }

    let address = {};
    address.name = this.state.user.name;

    if (this.state.retailer && this.state.retailer.address && this.state.user.addresses.length === 0) {
      address.address1 = this.state.retailer.address.address1;
      address.address2 = this.state.retailer.address.address2;
      address.postal_code = this.state.retailer.address.postal_code;
      address.city = this.state.retailer.address.city;
      address.state = this.state.retailer.address.state;
    }

    return (
      <div>
        <Steps current="3"/>
        <div className="add-address page-flyout">
          <h2>Add Shipping Address</h2>
          <EditAddress save={this.save} address={address} error={this.state.error} buttonText="Continue" />
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/checkout/AddAddressStep.js
 **/